import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import type Client from '@/models/client';


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientsMenu',
  props: {
    menu: { type: Boolean },
    clients: {},
    filteredClients: {},
    searchQuery: {}
  },
  emits: ["update:menu", "update:search-query", "select-client"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const menuModel = computed({
  get: () => props.menu,
  set: (value) => emit('update:menu', value)
});

const colors = {
  ACCENT: '#F29B00'
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    "offset-y": "",
    "close-on-content-click": false,
    modelValue: menuModel.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((menuModel).value = $event))
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps({
        block: "",
        color: colors.ACCENT
      }, props), {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createTextVNode(" Clients ")),
          _createVNode(_component_v_icon, {
            icon: menuModel.value ? 'mdi-chevron-up' : 'mdi-chevron-down',
            class: "ml-2"
          }, null, 8, ["icon"])
        ]),
        _: 2
      }, 1040, ["color"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                "model-value": _ctx.searchQuery,
                onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:search-query', ($event.target as HTMLInputElement).value))),
                label: "Search clients",
                "prepend-inner-icon": "mdi-magnify",
                "single-line": "",
                "hide-details": ""
              }, null, 8, ["model-value"])
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredClients, (item, index) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              key: index,
              onClick: ($event: any) => (_ctx.$emit('select-client', item))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})